// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import * as React from 'react';
import svg, { path } from 'react-native-svg';
function DrugIcon2(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.333 14.386a.333.333 0 1 0 .623-.233c-.433-1.163-1.167-1.633-1.883-2.187a.335.335 0 0 0-.47.057.332.332 0 0 0 .063.47c.72.563 1.3.927 1.667 1.893Z"
      />
      <path
        fill="currentColor"
        d="m22 12.463-2.596-2.016V7.5a1.334 1.334 0 0 0-1.334-1.333h-.653V4.583A.594.594 0 0 0 18.02 4V2.333a.273.273 0 0 1 .274-.27h2.58a.333.333 0 0 0 .333-.333V.333A.333.333 0 0 0 20.874 0h-5.167a1.73 1.73 0 0 0-1.727 1.73V4a.596.596 0 0 0 .604.593v1.574h-.64A1.333 1.333 0 0 0 12.61 7.5v2.947L10 12.463a3.81 3.81 0 0 0-1.486 3.03v14.84A1.667 1.667 0 0 0 10.18 32h11.64a1.666 1.666 0 0 0 1.667-1.667v-14.84A3.81 3.81 0 0 0 22 12.463Zm-8.723-2.906h5.447v.72h-5.447v-.72Zm1.37-7.827a1.063 1.063 0 0 1 1.06-1.063h4.833v.73h-2.246a.937.937 0 0 0-.94.936v1.584h-2.707V1.73Zm.603 2.853h1.5v1.584h-1.5V4.583ZM13.277 7.5a.667.667 0 0 1 .667-.667h4.113a.667.667 0 0 1 .667.667v1.39h-5.447V7.5ZM10.424 13l2.636-2.047h5.88L21.577 13a3.146 3.146 0 0 1 1.23 2.503v.38H9.194v-.39A3.146 3.146 0 0 1 10.424 13Zm12.383 15.917h-9.53V16.54h9.53v12.377ZM9.194 17.873h2.083v9.71H9.194v-9.71Zm0 10.377h2.416a.334.334 0 0 0 .334-.333V17.54a.333.333 0 0 0-.334-.333H9.194v-.667h3.416v12.377H9.194v-.667Zm12.626 3.083H10.18a1 1 0 0 1-1-1v-.75h13.627v.75a1 1 0 0 1-.987 1Z"
      />
      <path
        fill="currentColor"
        d="M14.626 28.25h7.29a.333.333 0 0 0 .334-.333V17.54a.333.333 0 0 0-.334-.333h-7.29a.333.333 0 0 0-.333.333v10.377a.333.333 0 0 0 .333.333Zm6.957-.666H14.96V25.25h6.623v2.334Zm0-9.71v6.71H14.96v-6.71h6.623Z"
      />
    </svg>
  );
}
export default DrugIcon2;
